export var StampDutyPropertyType;
(function (StampDutyPropertyType) {
    StampDutyPropertyType["NewHome"] = "NEW_HOME";
    StampDutyPropertyType["EstablishedHome"] = "ESTABLISHED_HOME";
    StampDutyPropertyType["VacantLand"] = "VACANT_LAND";
})(StampDutyPropertyType || (StampDutyPropertyType = {}));
//# sourceMappingURL=index.js.map